module.exports = __webpack_public_path__ + "img/rgbrands.fcc29709.png";